import { widgetWhitelistedLeadSources } from 'hx-analytics/src/constants/url-lead-source.constant';
import { globalLeadSource } from './get-url-lead-source.helper';
import { isSupportedLeadSource } from './is-supported-lead-source.helper';
import { doesWidgetSupportUrlLeadSource } from './does-widget-support-url-lead-source.helper';
export function getFirebaseCollectionName(widgetName) {
    if (!widgetName ||
        !globalLeadSource ||
        !doesWidgetSupportUrlLeadSource(widgetName) ||
        !isSupportedLeadSource(globalLeadSource)) {
        return widgetName;
    }
    return widgetWhitelistedLeadSources[widgetName][globalLeadSource];
}
